<script>

import {
  discountServiceList,
  getAvailableServiceList,
  getSubscription,
  getUserServiceList,
  saveOrgs
} from "@/api/subscriptions";

import * as organizationApi from '@/api/organizations';
import {mapActions, mapGetters} from "vuex";
import moment from "moment";

export default {
  name: 'SubscriptionSettingsPage',
  components: {},
  data() {

    this.setStep(1)

    let services = []

    let selected_services = []

    let discounts = []

    let period = 0
    let slots = 0
    let items = []

    let active_services = []
    getUserServiceList().then(
        (response) => {
          this.active_services = [...response.data.active_services, ...response.data.awaiting_services]
        }
    )

    discountServiceList().then(
        (json) => {
          this.discounts = json.data.data.periods
          this.setDiscounts(json.data.data.periods)
        }
    )

    getAvailableServiceList().then(
        (json) => {
          this.services = json.data.data.services
        }
    )

    return {
      current: {
        unit_count: 0,
        service: {
          name: ''
        },
        slots: []
      },
      services: services,
      selected_services: selected_services,
      durations: [],
      organizations: [],
      query: '',
      discounts: discounts,
      active_services: active_services,

      period: period,
      slots: slots,
      items: items
    }
  },

  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters('subscription', [
      'isChecked',
      'isModalVisible',
      'getBusySlots',
      'getSlots',
      'getItemSlots',
      'isSlotPresented',
      'getStep',
      'getItems',
      'getState',
      'getServices',
      'getItemSlotsList',
      'getDiscount',

      'getSettingsSlots',
      'getSettingsPeriod',
      'getSettingsItems',
      'getSettingsDiscount',
      'getSettingsItemSlots',
      'isInSettingsSlots',
      'getSettingsItemsLength'
    ]),
    ...mapGetters('user', ['USER_ID']),
    ...mapGetters('workspace', ['ID_WORK_SPACE']),
    serviceNum() {
      return this.services.filter(service => this.isChecked(service.id)).length;
    },
    orgList() {
      return this.organizations.filter(
          (item) => {
            return item.name.toLowerCase().includes(this.query.toLowerCase()) ||
                item.inn.toLowerCase().includes(this.query.toLowerCase())
          }
      )
    },
    getSum() {
      return this.getServices().map(
          (service) => {

            let discount = (100 - this.getDiscount(service.id)) / 100;
            return service.price_per_unit * this.getItemSlotsList(service.id).duration * this.getSlots(service.id) * discount;
          }
      ).reduce((acc, item) => acc + item, 0)
    },
    readyToNextStep() {
      return this.getSettingsSlots() > 0 || this.getSettingsPeriod() > 0;
    },
    onlySave() {
      return this.getNewSettingsSlotItems() === 0 && this.getSettingsPeriod() === 0
    }
  },
  methods: {
    ...mapActions('subscription',
        [
          'setSlots', 'hideModal', 'showModal', 'toggleItemSlot', 'setDiscounts', 'setStep', 'toggleService',
          'setSettingsSlots', 'setSettingsPeriod', 'setSettingsItems', 'toggleSettingsItemSlot', 'setCurrent',
          'addToSettingsSlots'
        ]
    ),
    save() {
      saveOrgs(
          {
            items: this.getSettingsItems(),
            subscription_id: this.current.id
          }
      ).then(() => {

        this.$router.push({name:'main_page'})
      })
    },
    getCurrentBusySlots() {
      return this.current.slots.length + this.getSettingsItems().length
    },
    getSettingsSlotsCount() {
      return this.current.unit_count >= this.current.slots.length ? Math.max(this.getSettingsSlots() -
          (this.current.unit_count - this.current.slots.length), 0) : this.getSettingsSlots()
    },
    getAvailableSlots() {
      return this.getSettingsSlotsCount() + this.current.unit_count - this.getCurrentBusySlots()
    },
    getTotalSlots() {
      return this.getSettingsSlots()
      // return this.current.unit_count + (this.current.unit_count > this.current.slots.length ? this.getSettingsSlots() - (this.current.unit_count - this.current.slots.length) : this.getSettingsSlots())
    },
    getNewSettingsSlotItems() {
      return this.getSettingsSlots() - this.current.unit_count
    },
    getMoment(date) {
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    alreadyInSubscriptionSlot(id) {
      return this.current.slots.filter((item) => {
        return item.entity_id === id
      }).length > 0
    },
    async load() {

      let response = await organizationApi.workspaceOrganizations(this.ID_WORK_SPACE);
      this.organizations = response.data.data.map(
          (item) => {
            return {
              id: item.id,
              entity_id: item.id,
              name: item.short_name,
              inn: item.inn
            }
          }
      )

      getSubscription(this.$route.params.id).then(
          (response) => {
            this.current = response.data
            this.addToSettingsSlots(this.current.slots)
          }
      )
    },

    showOrgList(service_id) {
      this.showModal(service_id)
      this.$refs.orgListDialog.showModal();
    },
    hideOrgList() {
      this.hideModal()
      this.$refs.orgListDialog.close()
    },

    getFinishDate(service) {
      const duration = this.getItemSlotsList(service.id).duration
      return this.getServiceStartDate(service.id).add(duration, 'M').format('D.MM.Y')
    },
    getStartDate(id) {
      return this.getServiceStartDate(id).format('D.MM.Y')
    },
    getServiceStartDate(id) {
      console.log(this.active_services)
      const index = this.active_services.map(param => param.service_id).lastIndexOf(id)
      console.log(index)
      if (this.active_services[index]) {
        if (moment(this.active_services[index].subscription_finish_date) > moment()) {
          return moment(this.active_services[index].subscription_finish_date, 'YYYY-MM-DD')
        }
      }
      return moment()
    }
  }
}
</script>

<template>
  <div class="ais24--subscription">
    <div class="ais24--container">
      <div class="ais24--steps">
        <ul class="ais24--steps__list">
          <li class="ais24--steps__item active">Настройка сервиса</li>
          <li class="ais24--steps__item">Детали подписки</li>
          <li class="ais24--steps__item">Оплата</li>
        </ul>
      </div>
      <header class="ais24--header">
        <h2 class="ais24--title">Настройка сервиса</h2>
      </header>
      <div class="ais24--services">
        <div class="ais24--services__info">
          <div class="ais24--alert ais24--alert--warning">
            <div class="ais24--alert__icon">
              <svg class="ais24--icon ais24--icon--24x24">
                <use xlink:href="/img/sprite.svg#icon-24-info-circle"></use>
              </svg>
            </div>
            <div class="ais24--alert__text">
              <p>Обращаем ваше внимание, что вы&nbsp;не&nbsp;можете уменьшить период или убрать организации в&nbsp;активной
                подписке. В&nbsp;настройке подписки доступно только добавление периода и&nbsp;организций.</p>
            </div>
          </div>
        </div>
        <ul class="ais24--services__list">
          <li class="ais24--services__item" v-if="current.id">
            <div class="ais24--service-card">
              <div class="ais24--service-card__header">
                <div class="ais24--service-card-preview">
                  <div class="ais24--service-card-preview__headline">
                    <h3 class="ais24--service-card-preview__title">Сервис &laquo;{{ current.service.name }}&raquo;</h3>
                    <p class="ais24--service-card-preview__caption">{{ current.service.description }}</p>
                  </div>
                  <div class="ais24--service-card-preview__status">
                    <div class="ais24--service-card-preview__label">
                      <span class="ais24--label ais24--label--success">Активен</span>
                    </div>
                    <div class="ais24--service-card-preview__details">Активен до
                      {{ getMoment(current.subscription_finish_date) }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="ais24--service-card__body">
                <div class="ais24--service-card-current">
                  <ul class="ais24--service-card-current__list">
                    <li class="ais24--service-card-current__item">
                      <div class="ais24--service-card-current__caption">Текущий период: <strong>{{ current.period }}
                        месяца</strong>
                      </div>
                      <div class="ais24--service-card-current__details">
                        <p>Действует с {{ getMoment(current.subscription_start_date) }} до
                          {{ getMoment(current.subscription_finish_date) }}</p>
                      </div>
                    </li>
                    <li class="ais24--service-card-current__item">
                      <div class="ais24--service-card-current__caption">Приобретено мест организаций:
                        <strong>{{ current.unit_count }}</strong>
                      </div>
                      <div class="ais24--service-card-current__details" v-if="current.slots.length">
                        <p>Добавленные организации
                          &laquo;{{ current.slots.map((item) => item.name).join('&raquo;, &laquo;') }}&raquo;
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="ais24--service-card-settings">
                  <div class="ais24--service-card-settings__caption">Добавьте период и/или настройте места
                    организаций:
                  </div>
                  <ul class="ais24--service-card-settings__list">
                    <li class="ais24--service-card-settings__item">
                      <div class="ais24--service-card-settings__headline">
                        <div class="ais24--service-card-settings__title">Добавить период</div>
                        <div class="ais24--service-card-settings__info"></div>
                      </div>
                      <div class="ais24--service-card-settings__details">
                        <div class="ais24--service-card-settings__title">{{ getSettingsPeriod() }} месяцев</div>
                        <div class="ais24--service-card-settings__info"></div>
                      </div>
                      <div class="ais24--service-card-settings__form">
                        <div class="ais24--field-counter">
                          <button class="ais24--button ais24--button--default ais24--button--medium" type="button"
                                  @click="setSettingsPeriod(getSettingsPeriod() - 1)"
                                  :disabled="getSettingsPeriod() <= 0">
                            <svg class="ais24--icon ais24--icon--24x24">
                              <use xlink:href="/img/sprite.svg#icon-24-minus"></use>
                            </svg>
                          </button>
                          <div class="ais24--field-counter__value">
                            <output class="ais24--field-counter__output">{{ getSettingsPeriod() }} мес.</output>
                            <span class="ais24--field-counter__label">{{ getSettingsDiscount() }}% скидка</span>
                          </div>
                          <button class="ais24--button ais24--button--primary ais24--button--medium" type="button"
                                  @click="setSettingsPeriod(getSettingsPeriod() + 1)">
                            <svg class="ais24--icon ais24--icon--24x24">
                              <use xlink:href="/img/sprite.svg#icon-24-plus"></use>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </li>
                    <li class="ais24--service-card-settings__item">
                      <div class="ais24--service-card-settings__headline">
                        <div class="ais24--service-card-settings__title">Добавить/настроить места</div>
                        <div class="ais24--service-card-settings__info">{{ current.service.price_per_unit }} руб/месяц
                          за место
                        </div>
                      </div>
                      <div class="ais24--service-card-settings__details">
                        <div class="ais24--service-card-settings__title">
                          {{ getNewSettingsSlotItems() > 0 ? '+' + getNewSettingsSlotItems() : 0 }} мест
                        </div>
                        <div class="ais24--service-card-settings__info"></div>
                      </div>
                      <div class="ais24--service-card-settings__form">
                        <div class="ais24--field-counter">
                          <button class="ais24--button ais24--button--default ais24--button--medium" type="button"
                                  :disabled="getTotalSlots() <= current.unit_count"
                                  @click="setSettingsSlots(getSettingsSlots() - 1)">
                            <svg class="ais24--icon ais24--icon--24x24">
                              <use xlink:href="/img/sprite.svg#icon-24-minus"></use>
                            </svg>
                          </button>
                          <div class="ais24--field-counter__value">
                            <output class="ais24--field-counter__output">{{ getTotalSlots() }} мест</output>
                            <span class="ais24--field-counter__label"></span>
                          </div>
                          <button class="ais24--button ais24--button--primary ais24--button--medium" type="button"
                                  @click="setSettingsSlots(getSettingsSlots() + 1)">
                            <svg class="ais24--icon ais24--icon--24x24">
                              <use xlink:href="/img/sprite.svg#icon-24-plus"></use>
                            </svg>
                          </button>
                        </div>
                        <!--                                :disabled="getAvailableSlots() < 1"-->
                        <button class="ais24--button ais24--button--secondary ais24--button--medium" type="button"
                                @click="showOrgList(current.service.id)">
                          <span class="ais24--button__text">Настроить</span>
                        </button>
                      </div>

                      <div class="ais24--service-card-settings__organizations">
                        <div class="ais24--chips">
                          <ul class="ais24--chips__list">
                            <!--                            <li class="ais24&#45;&#45;chips__item" v-for="item in current.slots" v-bind:key="item.id">-->
                            <!--                              <div class="ais24&#45;&#45;chips__title">{{ item.name }}</div>-->
                            <!--                              <button class="ais24&#45;&#45;chips__button" type="button" @click="toggleSettingsItemSlot(item)">-->
                            <!--                                <svg class="ais24&#45;&#45;icon ais24&#45;&#45;icon&#45;&#45;20x20">-->
                            <!--                                  <use xlink:href="/img/sprite.svg#icon-20-cross"></use>-->
                            <!--                                </svg>-->
                            <!--                              </button>-->
                            <!--                            </li>-->
                            <li class="ais24--chips__item" v-for="item in getSettingsItemSlots()" v-bind:key="item.id">
                              <div class="ais24--chips__title">{{ item.name }}</div>
                              <button class="ais24--chips__button" type="button" @click="toggleSettingsItemSlot(item)">
                                <svg class="ais24--icon ais24--icon--20x20">
                                  <use xlink:href="/img/sprite.svg#icon-20-cross"></use>
                                </svg>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>

                    </li>
                  </ul>
                </div>
              </div>
            </div><!--/.ais24--service-card-->
          </li>
        </ul><!--/.ais24--services__list-->
      </div><!--/.ais24--services-->
    </div><!--/.ais24--container-->
    <div class="ais24--actions-bar" v-if="current.id">
      <div class="ais24--container">
        <div class="ais24--actions-bar-holder">
          <div class="ais24--actions-bar-holder__previous">
            <a class="ais24--button ais24--button--outline ais24--button--large" href="#">
              <span class="ais24--button__text">Назад</span>
            </a>
          </div>
          <div class="ais24--actions-bar-holder__status">Настройте параметры сервиса, чтобы продолжить</div>
          <div class="ais24--actions-bar-holder__next" v-if="!onlySave">
            <router-link class="ais24--button ais24--button--primary ais24--button--large"
                         :to="{name: 'SubscriptionSettingsDetailsPage', params: {id: current.id}}"
                         :disabled="!readyToNextStep">
              <span class="ais24--button__text">Продолжить</span>
            </router-link>
          </div>
          <div class="ais24--actions-bar-holder__next" v-else>
            <button class="ais24--button ais24--button--primary ais24--button--large" :disabled="!readyToNextStep"
                    @click="save()">
              <span class="ais24--button__text">Сохранить</span>
            </button>
          </div>
        </div>
      </div>
    </div><!--/.ais24--actions-bar-->
    <dialog class="ais24--dialog ais24--dialog--medium" id="addOrganizations" data-type="popup" ref="orgListDialog">
      <button class="ais24--dialog-close" type="button" @click="hideOrgList">
        <svg class="ais24--icon ais24--icon--32x32">
          <use xlink:href="/img/sprite.svg#icon-32-cross-circle"></use>
        </svg>
      </button>
      <header class="ais24--dialog-header">
        <div class="ais24--dialog-header__headline">
          <h3 class="ais24--dialog-header__title">Добавить организации</h3>
          <div class="ais24--dialog-header__caption">Выберите организации из списка и добавьте их к сервису</div>
        </div>
        <div class="ais24--dialog-header__content">
          <fieldset class="ais24--fieldset">
            <div class="ais24--field-search">
              <input class="ais24--field-search__input" type="search" placeholder="Поиск по организациям или ИНН"
                     v-model="query">
            </div>
          </fieldset>
        </div>
      </header>
      <div class="ais24--dialog-body">
        <div class="ais24--organizations-choice">
          <ul class="ais24--organizations-choice__list">
            <!--            + (alreadyInSubscriptionSlot(org.id) ? ' disabled': '')-->
            <li :class="'ais24--organizations-choice__item'"
                v-for="org in orgList" v-bind:key="org.id">
              <div class="ais24--field-checkbox ais24--field-checkbox--bordered">
                <label class="ais24--field-checkbox__label">
                  <!--                         :disabled="alreadyInSubscriptionSlot(org.id)"-->
                  <input class="ais24--field-checkbox__input" type="checkbox"
                         :checked="isInSettingsSlots(org.id)" @click="toggleSettingsItemSlot(org)">
                  <span class="ais24--field-checkbox__title">
                    <span class="ais24--field-checkbox__caption">{{ org.name }}</span><br/>
                    <span class="ais24--field-checkbox__text">ИНН {{ org.inn }}</span>
                  </span>
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <footer class="ais24--dialog-footer">
        <div class="ais24--organizations-choice-action">
          <div class="ais24--organizations-choice-action__status">Занято мест
            <mark>{{ getSettingsItemsLength() }} из {{ getTotalSlots() }}</mark>
          </div>
          <button class="ais24--button ais24--button--primary ais24--button--large" type="button"
                  @click="hideOrgList">
            <span class="ais24--button__text">Продолжить</span>
          </button>
        </div>
      </footer>
    </dialog>
  </div>

</template>

<style scoped lang="scss">
.ais24--dialog .ais24--dialog-body {
  flex: auto;
}

.ais24--organizations-choice__item.disabled {
  color: gray;
}

.ais24--services {
  p {
    margin-bottom: 0;
  }
}
</style>
